function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pluck from 'ramda/src/pluck';
import CustomerCareKeys from '../../../../locales/keys';
import { BILLER_RULE_INSTANCE_TYPE } from '../../../../customercare.constants';
import { FREQUENCY_TYPES } from 'invision-core/src/constants/frequency.types.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
var LifeCycleStepsDialogController = /*#__PURE__*/function () {
  function LifeCycleStepsDialogController() {
    _classCallCheck(this, LifeCycleStepsDialogController);
    Object.assign(this, {
      BILLER_RULE_INSTANCE_TYPE: BILLER_RULE_INSTANCE_TYPE,
      CoreLocaleKeys: CoreLocaleKeys,
      CustomerCareKeys: CustomerCareKeys,
      getCurrentStepOfLifeCycle: this.getCurrentStepOfLifeCycle.bind(this),
      getDurationPeriodType: this.getDurationPeriodType.bind(this),
      saveLifeCycleForPricingPlan: this.saveLifeCycleForPricingPlan.bind(this),
      selectLifeCycle: this.selectLifeCycle.bind(this)
    });
  }
  return _createClass(LifeCycleStepsDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.lifeCyclePricingPlanDetails = this.lifeCycleDetails;
      this.lifeCycleBriDetails = this.lifeCycleChargeDetails;
      if (this.multipleLifeCycles) {
        var selectedLifeCycle = this.multipleLifeCycles.find(function (lifeCycle) {
          return lifeCycle.lifeCycleDetails.Id === _this.defaultLifeCycleId;
        });
        this.selectedLifeCycleId = selectedLifeCycle ? selectedLifeCycle.lifeCycleDetails.Id : this.multipleLifeCycles[0].lifeCycleDetails.Id;
        this.selectedLifeCycleIsEditable = selectedLifeCycle ? selectedLifeCycle.isEditable : this.multipleLifeCycles[0].isEditable;
        this.showEditLifeCycleMessage = pluck('isEditable', this.multipleLifeCycles).every(function (item) {
          return item === true;
        });
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changeObj) {
      if (changeObj.lifeCycleDetails && changeObj.lifeCycleDetails.currentValue) {
        this.lifeCyclePricingPlanDetails = this.lifeCycleDetails;
        this.lifeCycleBriDetails = this.lifeCycleChargeDetails;
      }
    }
  }, {
    key: "selectLifeCycle",
    value: function selectLifeCycle(lifeCycleId, isEditable) {
      this.selectedLifeCycleId = lifeCycleId;
      this.selectedLifeCycleIsEditable = isEditable;
    }
  }, {
    key: "getDialogTitle",
    value: function getDialogTitle() {
      if (this.multipleLifeCycles && this.disableLifeCycles) {
        return i18n.translate(CustomerCareKeys.LIFE_CYCLE.VIEW_LIFE_CYCLE);
      } else if (this.multipleLifeCycles) {
        return this.disableLifeCyclesEditOfferModal ? i18n.translate(CustomerCareKeys.LIFE_CYCLE.VIEW_LIFE_CYCLE) : i18n.translate(CustomerCareKeys.LIFE_CYCLE.EDIT_LIFE_CYCLE_TITLE);
      } else {
        return i18n.translate(CustomerCareKeys.LIFE_CYCLE.LIFE_CYCLE_TITLE);
      }
    }
  }, {
    key: "saveLifeCycleForPricingPlan",
    value: function saveLifeCycleForPricingPlan() {
      this.saveLifeCycle()(this.selectedLifeCycleId, this.selectedLifeCycleIsEditable);
    }
  }, {
    key: "getCurrentStepOfLifeCycle",
    value: function getCurrentStepOfLifeCycle(pricingPlan, lifeCycleId) {
      return pricingPlan.Id === this.activeLifeCyclePlan && this.selectedLifeCycleId === lifeCycleId;
    }
  }, {
    key: "getDurationPeriodType",
    value: function getDurationPeriodType(durationPeriodType) {
      switch (durationPeriodType) {
        case FREQUENCY_TYPES.DAILY:
          return i18n.translate(CoreLocaleKeys.PERIOD.DAYS);
        case FREQUENCY_TYPES.HOURLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.HOURS);
        case FREQUENCY_TYPES.MONTHLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.MONTHS);
        case FREQUENCY_TYPES.WEEKLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.WEEKS);
        case FREQUENCY_TYPES.YEARLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.YEARS);
        default:
          return '';
      }
    }
  }]);
}();
export default {
  template: require('./life.cycle.steps.dialog.html'),
  bindings: {
    activeLifeCyclePlan: '<?',
    currentLifeCyclePlan: '<?',
    defaultLifeCycleId: '<?',
    disableLifeCycles: '<?',
    disableLifeCyclesEditOfferModal: '<?',
    editOfferLifeCyclesInProductEditable: '<?',
    hideHighlightPlan: '<?',
    isLarge: '<?',
    isMeduim: '<?',
    lifeCycleChargeDetails: '<',
    lifeCycleDetails: '<',
    multipleLifeCycles: '<?',
    onClose: '&',
    saveLifeCycle: '&?'
  },
  controller: LifeCycleStepsDialogController
};